import { useCallback, useState } from "react";
import SearchModal from "./SearchModal";
import { IoSearchSharp } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { cn } from "../lib/utils";

const SearchBar = ({ isMobile }) => {
  const [openSearch, setOpenSearch] = useState(false);
  const { t } = useTranslation();

  const focusHandler = () => {
    setOpenSearch(!openSearch);
  };

  const handleClose = useCallback(() => setOpenSearch(false), []);

  return (
    <>
      <div className="relative">
        <IoSearchSharp
          cursor="pointer"
          onClick={focusHandler}
          color="black"
          className={cn(
            `hover:text-gray-200 hover:scale-110 transition-transform w-6 h-6`,
            isMobile ? " " : ""
          )}
        />
      </div>

      {/* Search modal, displayed when openSearch is true */}
      <SearchModal openSearch={openSearch} onClose={handleClose} />
    </>
  );
};

export default SearchBar;
